import { t } from 'i18next';

export class TranslationHelper {
    static getTranslatedText = (panel: string, section?: string): string => {
        if (panel) {
            const resourceKey = panel.toLowerCase().replaceAll(/[\W_]/g, '_');

            if (section) return t(`${section}.${resourceKey}`);
            else return t(resourceKey);
        } else return '';
    };
}
